export default __webpack_public_path__ + "img/locationAutocomplete.81057160.svg";